export const INDUSTRIES_META_DESCRIPTION_BG =
  "Perceptica предлага медиен мониторинг и медийни анализи за финтех, фармацевтични компании, FMCG, търговия на дребно и автомобилната индустрия в Югоизточна Европа.";
